import { all, takeLatest } from 'redux-saga/effects'

import { addPermissionAssignmentSaga } from './sagas/add-permission-assignment.saga'
import { addPublicPermissionAssignmentSaga } from './sagas/add-public-permission-assignment.saga'
import { saveSectionSaga } from './sagas/save-section.saga'
import { unpublishSectionSaga } from './sagas/unpublish.saga'
import { actionTypes } from './actions'

export function* sectionsWatchSaga() {
  yield all([
    takeLatest(actionTypes.SAVE_SECTION, saveSectionSaga),
    takeLatest(actionTypes.ADD_PERMISSION_ASSIGNMENT, addPermissionAssignmentSaga),
    takeLatest(actionTypes.ADD_PUBLIC_PERMISSION_ASSIGNMENT, addPublicPermissionAssignmentSaga),
    takeLatest(actionTypes.UNPUBLISH_SECTION, unpublishSectionSaga),
  ])
}
